import React from "react";
import { Result, Button, Card } from "antd";
//语言切换
import intl from "react-intl-universal";

export default function pageNotFound(props) {
  return (
    <Card bordered={false} style={{ minHeight: "calc(100vh - 130px)" }}>
      <Result
        status="404"
        title={intl.get("ef04c2f6-8e09-2f22-97b1-9c8968a998c5")}
        subTitle={intl.get("722fc57d-5ad3-2c05-9842-2d425d3f35a1")}
        extra={<Button type="primary" onClick={() => {
          props.history.push("/admin/home")
        }}>{intl.get("42c4ee5e-1f8c-2b7e-8595-425a3ae5d266")}</Button>}
      />
    </Card>
  );
}
